<div class="listings-container">
  <div class="container-fluid">

    <div class="row">
      <div class="col offset-lg-1 col-lg-10">
        <div class="listings-header d-none d-md-block">
            <h2 class="heading">Find Your Dream Home!</h2>
            <hr/>
            <span class="sub-title">View some of our current and past listings</span>
        </div>

        <marketing-banner class="d-block mt-3 mt-md-0 centered"></marketing-banner>

        <div class="our-homes-content">
          <div class="loading-overlay" *ngIf="loadingListings"(click)="$event.preventDefault(); $event.stopPropagation()">
            <div class="loading-dialog">
              <h3 class="loading-label">Finding Homes</h3>
              <img class="loading-spinner" src="assets/product/loading.gif" />
            </div>
          </div>

          <div>
            <span>Find {{ 'name' | branding | async }} listings in your area of interest below, or </span>
            <a textCta href="https://homesearch.houwzer.com/idx/search/basic?_ga=2.75073298.1209164887.1553185762-1076241007.1553090015">search all homes on the market</a>
          </div>

          <div class="row filter-group-row no-gutters">
            <div class="col-12 col-sm-3 filter-label-col">
              <span class="filter-label">
                <fa name="map"></fa>
                Filter By Location
                <span class="filter-count" *ngIf="this.appliedLocationFilterCount()">({{ this.appliedLocationFilterCount() }} active)</span>
                <a href="#" [hidden]="!phoneQuery.matches" class="expand-icon"
                (click)="$event.preventDefault(); this.showingMobileLocationFilters = !this.showingMobileLocationFilters">
                  <fa [name]="this.showingMobileLocationFilters ? 'minus-circle' : 'plus-circle'"></fa>
                </a>
              </span>
            </div>
            <div class="col-12 col-sm-9 pt-2 pt-sm-0">
              <div class="filter-dropdown-group" [hidden]="phoneQuery.matches && !this.showingMobileLocationFilters">
                  <ngx-bootstrap-multiselect (ngModelChange)="onStateChange($event)" [(ngModel)]="desiredStates"
                    [options]="filterStatesOptions | async" [texts]="filterStatesTexts"
                    [settings]="singleSelectionLimitSettings">
                  </ngx-bootstrap-multiselect>
                  <ngx-bootstrap-multiselect (ngModelChange)="onCountyChange($event)" [disabled]="!this.desiredStates"
                    [(ngModel)]="desiredCounties" [options]="filterCountiesOptions | async"
                    [texts]="filterCountiesTexts" [settings]="singleSelectionLimitSettings">
                  </ngx-bootstrap-multiselect>
                  <ngx-bootstrap-multiselect [disabled]="!this.desiredCounties || !this.desiredStates"
                    [(ngModel)]="desiredCountySubdivisions" [options]="filterCountySubdivisionOptions | async"
                    [texts]="filterCountySubdivisionTexts | async" [settings]="filterCountySubdivisionSettings">
                  </ngx-bootstrap-multiselect>
              </div>
            </div>
          </div>

          <div class="row filter-group-row no-gutters">
            <div class="col-12 col-sm-3 filter-label-col">
              <span class="filter-label">
                <fa name="bed"></fa>
                Filter By Property
                <span class="filter-count"
                  *ngIf="this.appliedPropertyFilterCount()">({{ this.appliedPropertyFilterCount() }} active)</span>
                <a href="#" [hidden]="!phoneQuery.matches" class="expand-icon"
                  (click)="$event.preventDefault(); this.showingMobilePropertyFilters = !this.showingMobilePropertyFilters">
                  <fa [name]="this.showingMobilePropertyFilters ? 'minus-circle' : 'plus-circle'"></fa>
                </a>
              </span>
            </div>
            <div class="col-12 col-sm-9 pt-2 pt-sm-0">
              <div class="filter-dropdown-group" [hidden]="phoneQuery.matches && !this.showingMobilePropertyFilters">
                  <ngx-bootstrap-multiselect [(ngModel)]="desiredBeds" [options]="filterBedOptions"
                    [texts]="filterBedsTexts" [settings]="singleSelectionLimitSettings">
                  </ngx-bootstrap-multiselect>
                  <ngx-bootstrap-multiselect [(ngModel)]="desiredFullBaths" [options]="filterFullBathOptions"
                    [texts]="filterFullBathsTexts" [settings]="singleSelectionLimitSettings">
                  </ngx-bootstrap-multiselect>
                  <ngx-bootstrap-multiselect [(ngModel)]="desiredHalfBaths" [options]="filterHalfBathOptions"
                    [texts]="filterHalfBathsTexts" [settings]="singleSelectionLimitSettings">
                  </ngx-bootstrap-multiselect>
                  <ngx-bootstrap-multiselect [(ngModel)]="desiredSqft" [options]="filterSqftOptions"
                    [texts]="filterSqftTexts" [settings]="singleSelectionLimitSettings">
                  </ngx-bootstrap-multiselect>
              </div>
            </div>
          </div>

          <div class="row filter-group-row no-gutters">
            <div class="col-12 col-sm-3 filter-label-col">
              <span class="filter-label">
                <fa name="tag"></fa>
                Filter By Listing
                <span class="filter-count"
                  *ngIf="this.appliedListingFilterCount()">({{ this.appliedListingFilterCount() }}&nbsp;active)</span>
                <a href="#" [hidden]="!phoneQuery.matches" class="expand-icon"
                  (click)="$event.preventDefault(); this.showingMobileListingFilters = !this.showingMobileListingFilters">
                  <fa [name]="this.showingMobileListingFilters ? 'minus-circle' : 'plus-circle'"></fa>
                </a>
              </span>
            </div>
            <div class="col-12 col-sm-9 pt-2 pt-sm-0">
              <div class="filter-dropdown-group" [hidden]="phoneQuery.matches && !this.showingMobileListingFilters">
                  <ngx-bootstrap-multiselect [(ngModel)]="desiredStatuses" [options]="filterStatusesOptions"
                    [texts]="filterStatusesTexts" [settings]="filterStatusesSettings">
                  </ngx-bootstrap-multiselect>
                  <ngx-bootstrap-multiselect [(ngModel)]="desiredMinPrice" [options]="filterMinPriceOptions"
                    [texts]="filterMinPriceTexts" [settings]="singleSelectionLimitSettings">
                  </ngx-bootstrap-multiselect>
                  <ngx-bootstrap-multiselect [(ngModel)]="desiredMaxPrice" [options]="filterMaxPriceOptions"
                    [texts]="filterMaxPriceTexts" [settings]="singleSelectionLimitSettings">
                  </ngx-bootstrap-multiselect>
              </div>
            </div>
          </div>

          <div class="row action-row filter-submit-row no-gutters">
            <div class="col-xs-12 col-sm-9  offset-sm-3">
              <button #applyButton class="btn btn-primary" [disabled]="!unappliedFilterCount()">{{ applyButtonText() }}</button>
            </div>
          </div>

          <div class="row mt-3" *ngIf="(pins | async).length; else mapPlaceholder">
            <div class="col-12">
              <listings-map [pins]="pins" [selectedStatuses]="selectedStatuses"></listings-map>
            </div>
          </div>

          <ng-template #mapPlaceholder>
            <!-- we derender and rerender the map with every filter change, this prevents jarring page jumping  -->
            <div class="map-placeholder mt-3"></div>
          </ng-template>

          <div class="row">
            <div class="col">
              <!-- Note we're using [hidden] instead of *ngIf because it appears the paginator will use the correct initialPageSize unless it's actually on the page from the start -->
              <mat-paginator #topPaginator [length]="length" [pageIndex]="pageIndex" [pageSize]="pageSize" [hidden]="!this.showPaginator" [pageSizeOptions]="pageSizeOptions" (page)="handlePageChange($event)"></mat-paginator>
            </div>
          </div>
          <div class="row">
            <div class="col text-center" *ngIf="this.listingTimelines && !this.listingTimelines.length">
              <p class="no-results-message">Oops! We couldn't find any listings for your search criteria.</p>
            </div>
          </div>
          <div class="row listing-tiles-container">
            <div *ngFor="let listingTimeline of listingTimelines" class="col-xs-12 col-sm-6 col-lg-4 col-xl-3">
              <listing-tile [listingTimeline]="listingTimeline"></listing-tile>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <!-- Note we're using [hidden] instead of *ngIf because it appears the paginator will use the correct initialPageSize unless it's actually on the page from the start -->
              <mat-paginator #bottomPaginator [length]="length" [pageIndex]="pageIndex" [pageSize]="pageSize" [hidden]="!this.showPaginator" [pageSizeOptions]="pageSizeOptions" (page)="handlePageChange($event)"></mat-paginator>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
